/* THE ALIENS - Pixel Streetwear theme JS (vanilla, no dependencies) */
(function () {
  'use strict';
  var D = document, W = window;
  var T = W.THEME || {};
  var R = T.routes || {};
  R.root = R.root || '/';
  R.cartJs = R.cartJs || '/cart.js';
  R.add = R.add || '/cart/add.js';
  R.change = R.change || '/cart/change.js';
  var $ = function (s, r) { return (r || D).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || D).querySelectorAll(s)); };
  var clamp = function (v, a, b) { return Math.min(b, Math.max(a, v)); };
  var reduce = W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = D.documentElement;

  /* ------------------------------------------------ money */
  function withDelims(cents, precision, thousands, decimal) {
    var n = (cents / 100).toFixed(precision);
    var p = n.split('.');
    var d = p[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return d + (p[1] ? decimal + p[1] : '');
  }
  function money(cents) {
    var f = T.moneyFormat || 'Rs. {{amount_no_decimals}}';
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      switch (k) {
        case 'amount': return withDelims(cents, 2, ',', '.');
        case 'amount_no_decimals': return withDelims(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(cents, 0, '.', ',');
        case 'amount_no_decimals_with_space_separator': return withDelims(cents, 0, ' ', ',');
        case 'amount_with_apostrophe_separator': return withDelims(cents, 2, "'", '.');
        default: return withDelims(cents, 2, ',', '.');
      }
    });
  }

  /* ------------------------------------------------ toast */
  var toastEl, toastT;
  function toast(msg) {
    if (!toastEl) { toastEl = D.createElement('div'); toastEl.className = 'toast'; toastEl.setAttribute('role', 'status'); D.body.appendChild(toastEl); }
    toastEl.textContent = msg;
    toastEl.classList.add('show');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('show'); }, 2200);
  }

  /* ------------------------------------------------ pixel transition */
  function pixelFx(dir, done) {
    if (reduce || !D.body) { root.classList.remove('pxl-cover'); if (done) done(); return; }
    var c = D.createElement('canvas');
    c.className = 'pxfx';
    var w = c.width = W.innerWidth, h = c.height = W.innerHeight;
    D.body.appendChild(c);
    var ctx = c.getContext('2d');
    var size = Math.max(40, Math.round(Math.min(w, h) / 11));
    var cols = Math.ceil(w / size), rows = Math.ceil(h / size);
    var pal = ['#aaaaaa', '#aaaaaa', '#aaaaaa', '#aaaaaa', '#b8b8b8', '#ffffff', '#ff8a0b', '#6b4a2a'];
    var cells = [], r, q;
    for (r = 0; r < rows; r++) {
      for (q = 0; q < cols; q++) {
        var diag = ((cols - 1 - q) / cols + r / rows) / 2;
        cells.push({ x: q * size, y: r * size, d: diag * 0.55 + Math.random() * 0.3, c: pal[Math.floor(Math.random() * pal.length)] });
      }
    }
    var dur = dir === 'out' ? 1100 : 650, t0 = null;
    function paint(t) {
      ctx.clearRect(0, 0, w, h);
      for (var i = 0; i < cells.length; i++) {
        var cell = cells[i];
        var local = clamp((t - cell.d) / 0.3, 0, 1);
        var p = dir === 'out' ? 1 - local : local;
        if (p <= 0) continue;
        var s = p >= 1 ? size + 1 : size * (0.3 + 0.7 * p);
        ctx.globalAlpha = p >= 1 ? 1 : clamp(p * 1.5, 0, 1);
        ctx.fillStyle = cell.c;
        ctx.fillRect(cell.x + (size - s) / 2, cell.y + (size - s) / 2, s, s);
      }
      ctx.globalAlpha = 1;
    }
    paint(dir === 'out' ? -1 : 0);
    root.classList.remove('pxl-cover');
    function frame(ts) {
      if (!t0) t0 = ts;
      var t = (ts - t0) / dur;
      paint(t);
      if (t < 1.25) { requestAnimationFrame(frame); }
      else {
        if (dir === 'out') c.remove();
        if (done) done();
      }
    }
    requestAnimationFrame(frame);
    return c;
  }

  function initTransitions() {
    if (T.demo || T.pixelTransition === false) return;
    D.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      var h = a.getAttribute('href');
      if (!h || h.charAt(0) === '#' || /^(mailto:|tel:|javascript:)/i.test(h)) return;
      if (a.target && a.target !== '_self') return;
      if (a.hasAttribute('download')) return;
      var u;
      try { u = new URL(a.href, W.location.href); } catch (er) { return; }
      if (u.origin !== W.location.origin) return;
      if (u.pathname === W.location.pathname && u.search === W.location.search) return;
      e.preventDefault();
      pixelFx('in', function () { W.location.href = a.href; });
      setTimeout(function () { W.location.href = a.href; }, 1600);
    });
    W.addEventListener('pageshow', function (ev) {
      if (ev.persisted) { $$('.pxfx').forEach(function (n) { n.remove(); }); root.classList.remove('pxl-cover'); }
    });
  }

  /* ------------------------------------------------ typewriter */
  function prepTw(el) {
    if (el.__tw) return;
    el.__tw = true;
    el.setAttribute('aria-label', el.textContent.replace(/\s+/g, ' ').trim());
    var frag = D.createDocumentFragment();
    Array.prototype.slice.call(el.childNodes).forEach(function (n) {
      if (n.nodeType === 3) {
        n.textContent.split('').forEach(function (ch) {
          var s = D.createElement('span');
          s.className = 'tw-c'; s.setAttribute('aria-hidden', 'true'); s.textContent = ch;
          frag.appendChild(s);
        });
      } else { frag.appendChild(n.cloneNode(true)); }
    });
    el.innerHTML = '';
    el.appendChild(frag);
  }
  function playTw(el) {
    var cs = $$('.tw-c', el);
    cs.forEach(function (c, i) {
      if (reduce) { c.classList.add('on'); return; }
      setTimeout(function () { c.classList.add('on'); }, 160 + i * 45);
    });
  }

  /* ------------------------------------------------ reveal on scroll */
  function initReveal() {
    var items = $$('.rv,.rvx,.st,.bn,.cat,[data-tw]');
    $$('[data-tw]').forEach(prepTw);
    $$('[data-stagger]').forEach(function (p) {
      $$(':scope > *', p).forEach(function (c, i) { c.style.setProperty('--d', i * 70); });
    });
    if (!('IntersectionObserver' in W)) {
      items.forEach(function (el) { el.classList.add('in'); if (el.hasAttribute('data-tw')) playTw(el); });
      return;
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('in');
        if (e.target.hasAttribute('data-tw')) playTw(e.target);
        io.unobserve(e.target);
        if (e.target.__onin) e.target.__onin();
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -6% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ------------------------------------------------ hero parallax */
  function initHero() {
    var hero = $('.hero');
    if (!hero) return;
    var tick = false;
    function upd() {
      tick = false;
      var r = hero.getBoundingClientRect();
      var p = clamp(-r.top / Math.max(1, r.height), 0, 1);
      hero.style.setProperty('--p', p.toFixed(4));
    }
    W.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(upd); } }, { passive: true });
    upd();
    var fig = $('.hero__fig', hero);
    if (fig && !reduce && W.matchMedia('(min-width:901px)').matches) {
      hero.addEventListener('mousemove', function (e) {
        var x = (e.clientX / W.innerWidth - 0.5) * 2;
        fig.style.setProperty('--mx', (x * 0.8).toFixed(2) + 'rem');
      });
    }
  }
  function startHero() {
    var hero = $('.hero');
    if (hero) hero.classList.add('in');
  }

  /* ------------------------------------------------ feature slider */
  function initSlider() {
    var rootEl = $('.fs');
    if (!rootEl) return;
    var tr = $('.fs__track', rootEl);
    var cards = $$('.fcard', tr);
    var dotsWrap = $('.fs__dots', rootEl);
    if (!tr || !cards.length) return;
    var dots = [];
    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      cards.forEach(function (c, i) {
        var b = D.createElement('button');
        b.type = 'button'; b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        b.addEventListener('click', function () { go(i); pause(); });
        dotsWrap.appendChild(b); dots.push(b);
      });
    }
    function current() {
      var best = 0, bd = 1e9, base = tr.getBoundingClientRect().left;
      cards.forEach(function (c, i) {
        var d = Math.abs(c.getBoundingClientRect().left - base);
        if (d < bd) { bd = d; best = i; }
      });
      return best;
    }
    function mark() {
      var i = current();
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
    }
    function go(i) {
      i = clamp(i, 0, cards.length - 1);
      var left = cards[i].getBoundingClientRect().left - cards[0].getBoundingClientRect().left;
      tr.scrollTo({ left: left, behavior: reduce ? 'auto' : 'smooth' });
    }
    tr.addEventListener('scroll', function () { requestAnimationFrame(mark); }, { passive: true });
    mark();
    var down = false, sx = 0, sl = 0, moved = 0;
    tr.addEventListener('mousedown', function (e) { down = true; moved = 0; sx = e.pageX; sl = tr.scrollLeft; tr.classList.add('drag'); });
    W.addEventListener('mouseup', function () { if (down) { down = false; tr.classList.remove('drag'); pause(); } });
    W.addEventListener('mousemove', function (e) { if (!down) return; moved = Math.abs(e.pageX - sx); tr.scrollLeft = sl - (e.pageX - sx); });
    tr.addEventListener('click', function (e) { if (moved > 6) { e.preventDefault(); e.stopPropagation(); } moved = 0; }, true);
    var paused = false, timer;
    function pause() { paused = true; clearTimeout(timer); timer = setTimeout(function () { paused = false; }, 9000); }
    tr.addEventListener('mouseenter', function () { paused = true; });
    tr.addEventListener('mouseleave', function () { paused = false; });
    tr.addEventListener('touchstart', pause, { passive: true });
    if (!reduce) {
      setInterval(function () {
        if (paused || D.hidden) return;
        var r = rootEl.getBoundingClientRect();
        if (r.bottom < 0 || r.top > W.innerHeight) return;
        var i = current();
        var max = tr.scrollWidth - tr.clientWidth;
        if (tr.scrollLeft >= max - 4) go(0); else go(i + 1);
      }, 4800);
    }
  }

  /* ------------------------------------------------ catalog tabs + pagination */
  function initCatalog() {
    $$('.cat').forEach(function (cat) {
      var tabs = $$('.tab', cat), panels = $$('.cat__panel', cat), pager = $('.pager', cat);
      var per = parseInt(cat.getAttribute('data-per'), 10) || 8;
      if (!panels.length) return;
      var pi = 0, pg = 1, firstDone = false;
      var arrowL = '<svg viewBox="0 0 12 12"><path fill="currentColor" d="M1 5h2V4h1V3h1V2h2v1H6v1H5v1h6v2H5v1h1v1h1v1H5V9H4V8H3V7H1z"/></svg>';
      var arrowR = '<svg viewBox="0 0 12 12"><path fill="currentColor" d="M11 5H9V4H8V3H7V2H5v1h1v1h1v1H1v2h6v1H6v1H5v1h2V9h1V8h1V7h2z"/></svg>';
      function pad(n) { return n < 10 ? '0' + n : '' + n; }
      function show(newPi, newPg, animate) {
        pi = newPi;
        panels.forEach(function (p, i) { p.hidden = i !== pi; });
        tabs.forEach(function (t, i) { t.classList.toggle('is-active', i === pi); t.setAttribute('aria-selected', i === pi ? 'true' : 'false'); });
        var items = $$('.pcard', panels[pi]);
        var pages = Math.max(1, Math.ceil(items.length / per));
        pg = clamp(newPg, 1, pages);
        items.forEach(function (it, i) {
          var on = i >= (pg - 1) * per && i < pg * per;
          it.hidden = !on;
          it.classList.remove('is-quick');
          if (on && animate && !reduce) {
            it.classList.remove('pop-in'); void it.offsetWidth;
            it.style.setProperty('--i', i - (pg - 1) * per);
            it.classList.add('pop-in');
          }
        });
        if (pager) {
          if (pages < 2) { pager.hidden = true; pager.innerHTML = ''; }
          else {
            pager.hidden = false;
            var h = '<button type="button" class="arrow prev" aria-label="Previous page"' + (pg === 1 ? ' disabled' : '') + '>' + arrowL + '</button>';
            for (var k = 1; k <= pages; k++) h += '<button type="button" data-pg="' + k + '" class="' + (k === pg ? 'is-on' : '') + '">' + pad(k) + '</button>';
            h += '<button type="button" class="arrow next" aria-label="Next page"' + (pg === pages ? ' disabled' : '') + '>' + arrowR + '</button>';
            pager.innerHTML = h;
          }
        }
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { show(i, 1, true); });
      });
      if (pager) {
        pager.addEventListener('click', function (e) {
          var b = e.target.closest('button');
          if (!b || b.disabled) return;
          var np = pg;
          if (b.classList.contains('prev')) np = pg - 1;
          else if (b.classList.contains('next')) np = pg + 1;
          else if (b.getAttribute('data-pg')) np = parseInt(b.getAttribute('data-pg'), 10);
          show(pi, np, true);
          var top = cat.querySelector('.cat__tabs');
          if (top) { var y = top.getBoundingClientRect().top + W.pageYOffset - 80; W.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' }); }
        });
      }
      var start = 0;
      tabs.forEach(function (t, i) { if (t.classList.contains('is-active')) start = i; });
      show(start, 1, false);
      cat.__onin = function () { if (!firstDone) { firstDone = true; show(pi, pg, true); } };
    });
  }

  /* ------------------------------------------------ wishlist */
  var WL_KEY = 'aliens_wishlist';
  function wlGet() { try { return JSON.parse(localStorage.getItem(WL_KEY)) || []; } catch (e) { return []; } }
  function wlSet(a) { try { localStorage.setItem(WL_KEY, JSON.stringify(a)); } catch (e) {} }
  function wlSync() {
    var list = wlGet();
    $$('.js-wish').forEach(function (b) {
      var on = list.indexOf(b.getAttribute('data-handle')) > -1;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
    });
    $$('[data-wish-count]').forEach(function (el) { el.textContent = list.length || ''; el.setAttribute('data-n', list.length); });
    if (dr && dr.classList.contains('is-open') && drTab === 'wish') renderWish();
  }
  function wlToggle(handle) {
    var list = wlGet(), i = list.indexOf(handle);
    if (i > -1) { list.splice(i, 1); toast('Removed from wishlist'); }
    else { list.push(handle); toast('Saved to wishlist'); }
    wlSet(list); wlSync();
  }

  /* ------------------------------------------------ product info lookups */
  var infoCache = {};
  function domInfo(handle) {
    var card = $('.pcard[data-handle="' + handle + '"]');
    if (!card) return null;
    var media = $('.pcard__media', card);
    return {
      handle: handle, title: card.getAttribute('data-title'), price: parseInt(card.getAttribute('data-price'), 10) || 0,
      url: card.getAttribute('data-url') || '#', imageHtml: media ? media.innerHTML : '',
      variantId: card.getAttribute('data-variant'), single: card.getAttribute('data-single') !== 'false'
    };
  }
  function getInfo(handle) {
    if (infoCache[handle]) return Promise.resolve(infoCache[handle]);
    var d = domInfo(handle);
    if (T.demo || d) { if (d) { infoCache[handle] = d; } return Promise.resolve(d); }
    return fetch(R.root + 'products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
      var info = {
        handle: handle, title: p.title, price: p.price, url: p.url,
        imageHtml: p.featured_image ? '<img src="' + p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') + '" alt="">' : '',
        variantId: p.variants && p.variants[0] ? p.variants[0].id : null,
        single: p.variants && p.variants.length === 1
      };
      infoCache[handle] = info; return info;
    }).catch(function () { return null; });
  }

  /* ------------------------------------------------ cart */
  var demoItems = [];
  var cartState = { items: [], total: 0, count: 0 };
  function normShopify(c) {
    return {
      count: c.item_count, total: c.total_price,
      items: c.items.map(function (i) {
        return {
          key: i.key, id: i.variant_id, title: i.product_title, variant: i.variant_title, price: i.final_price, qty: i.quantity, url: i.url,
          imageHtml: i.image ? '<img src="' + i.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') + '" alt="">' : ''
        };
      })
    };
  }
  function demoCart() {
    var count = 0, total = 0;
    demoItems.forEach(function (i) { count += i.qty; total += i.qty * i.price; });
    return { count: count, total: total, items: demoItems.slice() };
  }
  var Cart = {
    load: function () {
      if (T.demo) return Promise.resolve(demoCart());
      return fetch(R.cartJs, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(normShopify);
    },
    add: function (id, qty, info) {
      qty = qty || 1;
      if (T.demo) {
        var found = demoItems.filter(function (i) { return String(i.id) === String(id); })[0];
        if (found) found.qty += qty;
        else demoItems.push({ key: String(id), id: id, title: info.title, variant: info.variant || '', price: info.price, qty: qty, url: info.url || '#', imageHtml: info.imageHtml || '' });
        return Promise.resolve(demoCart());
      }
      return fetch(R.add, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: qty }] }) })
        .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Could not add'); }); return r.json(); })
        .then(function () { return Cart.load(); });
    },
    change: function (key, qty) {
      if (T.demo) {
        demoItems = demoItems.filter(function (i) { if (i.key === key) { i.qty = qty; } return i.qty > 0; });
        return Promise.resolve(demoCart());
      }
      return fetch(R.change, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
        .then(function (r) { return r.json(); }).then(normShopify);
    }
  };
  function renderCart(c) {
    cartState = c;
    $$('[data-cart-count]').forEach(function (el) { el.textContent = c.count || ''; el.setAttribute('data-n', c.count); });
    var body = $('[data-view="cart"]');
    if (!body) return;
    if (!c.items.length) { body.innerHTML = '<p class="dr__empty">Your cart is empty</p>'; }
    else {
      body.innerHTML = c.items.map(function (i) {
        return '<div class="li" data-key="' + i.key + '"><a class="li__img" href="' + i.url + '">' + i.imageHtml + '</a>' +
          '<div><h5>' + esc(i.title) + '</h5>' + (i.variant && i.variant !== 'Default Title' ? '<small>' + esc(i.variant) + '</small>' : '') +
          '<div class="qty"><button type="button" data-act="minus" aria-label="Less">-</button><span>' + i.qty + '</span><button type="button" data-act="plus" aria-label="More">+</button></div>' +
          '<button type="button" class="li__rm" data-act="rm">Remove</button></div>' +
          '<div class="li__p">' + money(i.price * i.qty) + '</div></div>';
      }).join('');
    }
    var tot = $('[data-cart-total]'); if (tot) tot.innerHTML = money(c.total);
    var foot = $('[data-cart-foot]'); if (foot) foot.hidden = !c.items.length || drTab !== 'cart';
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); }

  function renderWish() {
    var body = $('[data-view="wish"]');
    if (!body) return;
    var list = wlGet();
    if (!list.length) { body.innerHTML = '<p class="dr__empty">No saved pieces yet</p>'; return; }
    body.innerHTML = '<p class="dr__empty">Loading</p>';
    Promise.all(list.map(getInfo)).then(function (infos) {
      var h = '';
      infos.forEach(function (i, k) {
        if (!i) return;
        h += '<div class="li" data-handle="' + list[k] + '"><a class="li__img" href="' + i.url + '">' + i.imageHtml + '</a>' +
          '<div><h5>' + esc(i.title) + '</h5>' +
          (i.single && i.variantId ? '<button type="button" class="btn btn--teal" style="padding:.55rem .8rem;margin-top:.4rem" data-act="wadd" data-variant-id="' + i.variantId + '">Add to cart</button>'
            : '<a class="btn btn--teal" style="padding:.55rem .8rem;margin-top:.4rem" href="' + i.url + '">Choose size</a>') +
          '<button type="button" class="li__rm" data-act="wrm">Remove</button></div>' +
          '<div class="li__p">' + money(i.price) + '</div></div>';
      });
      body.innerHTML = h || '<p class="dr__empty">No saved pieces yet</p>';
    });
  }

  /* drawer */
  var dr, drTab = 'cart';
  function setTab(t) {
    drTab = t;
    $$('.dr__tabs button').forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-tab') === t); });
    $$('[data-view]').forEach(function (v) { v.hidden = v.getAttribute('data-view') !== t; });
    var foot = $('[data-cart-foot]'); if (foot) foot.hidden = t !== 'cart' || !cartState.items.length;
    if (t === 'wish') renderWish();
  }
  function openDr(tab) {
    if (!dr) return;
    setTab(tab || 'cart');
    dr.classList.add('is-open');
    dr.setAttribute('aria-hidden', 'false');
    D.body.style.overflow = 'hidden';
  }
  function closeDr() {
    if (!dr) return;
    dr.classList.remove('is-open');
    dr.setAttribute('aria-hidden', 'true');
    D.body.style.overflow = '';
  }

  function addToCart(btn, id, info) {
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding'; }
    Cart.add(id, 1, info).then(function (c) {
      renderCart(c);
      if (btn) { btn.textContent = 'Added'; setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1100); }
      openDr('cart');
    }).catch(function (err) {
      if (btn) { btn.textContent = label; btn.disabled = false; }
      toast(err && err.message ? err.message : 'Could not add to cart');
    });
  }

  function initActions() {
    dr = $('.dr');
    D.addEventListener('click', function (e) {
      var t = e.target;
      var el;
      if ((el = t.closest('.js-wish'))) { e.preventDefault(); wlToggle(el.getAttribute('data-handle')); return; }
      if ((el = t.closest('.js-quick'))) {
        e.preventDefault();
        var card = el.closest('.pcard');
        var was = card.classList.contains('is-quick');
        $$('.pcard.is-quick').forEach(function (c) { c.classList.remove('is-quick'); });
        if (!was) card.classList.add('is-quick');
        return;
      }
      if ((el = t.closest('.js-add'))) {
        e.preventDefault();
        var cardEl = el.closest('.pcard');
        var info = null;
        if (cardEl) {
          info = domInfo(cardEl.getAttribute('data-handle')) || {};
          if (el.classList.contains('chip')) info.variant = el.textContent;
        }
        addToCart(el.classList.contains('chip') ? null : el, el.getAttribute('data-variant-id'), info || {});
        if (cardEl) cardEl.classList.remove('is-quick');
        return;
      }
      if ((el = t.closest('[data-open-cart]'))) { e.preventDefault(); openDr('cart'); return; }
      if ((el = t.closest('[data-open-wish]'))) { e.preventDefault(); openDr('wish'); return; }
      if (t.closest('[data-close-dr]')) { closeDr(); return; }
      if ((el = t.closest('.dr__tabs button'))) { setTab(el.getAttribute('data-tab')); return; }
      if ((el = t.closest('[data-act]'))) {
        var act = el.getAttribute('data-act'), row = el.closest('.li');
        if (act === 'wrm') { var l = wlGet(), h = row.getAttribute('data-handle'); l.splice(l.indexOf(h), 1); wlSet(l); wlSync(); return; }
        if (act === 'wadd') { var hh = row.getAttribute('data-handle'); getInfo(hh).then(function (inf) { addToCart(el, el.getAttribute('data-variant-id'), inf || {}); }); return; }
        var key = row && row.getAttribute('data-key');
        var item = cartState.items.filter(function (i) { return String(i.key) === String(key); })[0];
        if (!item) return;
        var q = act === 'plus' ? item.qty + 1 : act === 'minus' ? item.qty - 1 : 0;
        Cart.change(item.key, q).then(renderCart);
        return;
      }
      if ((el = t.closest('.hdr__burger'))) { D.body.classList.toggle('nav-open'); return; }
      if (t.closest('.hdr__nav a')) { D.body.classList.remove('nav-open'); }
      if (!t.closest('.pcard')) { $$('.pcard.is-quick').forEach(function (c) { c.classList.remove('is-quick'); }); }
    });
    D.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDr(); D.body.classList.remove('nav-open'); } });
    wlSync();
    Cart.load().then(renderCart).catch(function () {});
    setTab('cart');
  }

  /* ------------------------------------------------ product page */
  function initProduct() {
    var wrap = $('.js-product');
    if (!wrap) return;
    var vjson = $('[data-variants]', wrap);
    var variants = vjson ? JSON.parse(vjson.textContent) : [];
    var form = $('form', wrap);
    var idInput = $('[name="id"]', wrap);
    var priceEl = $('[data-price]', wrap);
    var btn = $('.js-pbtn', wrap);
    var qtyEl = $('[name="quantity"]', wrap);
    function selected() {
      var vals = [];
      $$('.opt', wrap).forEach(function (fs) { var c = $('input:checked', fs); vals.push(c ? c.value : null); });
      return variants.filter(function (v) { return v.options.join('|') === vals.join('|'); })[0];
    }
    function update() {
      if (!variants.length) return;
      var v = selected();
      if (idInput) idInput.value = v ? v.id : '';
      if (priceEl) {
        priceEl.innerHTML = v ? ((v.compare_at_price && v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s>' : '') + money(v.price)) : '';
      }
      if (btn) {
        btn.disabled = !v || !v.available;
        btn.textContent = !v ? 'Unavailable' : (v.available ? 'Add to cart' : 'Sold out');
      }
      if (v && W.history && W.history.replaceState && !T.demo) {
        var u = new URL(W.location.href); u.searchParams.set('variant', v.id); W.history.replaceState({}, '', u);
      }
      if (v && v.featured_media && v.featured_media.id) {
        var m = $('.m[data-mid="' + v.featured_media.id + '"]', wrap);
        if (m) setMedia(m.getAttribute('data-i'));
      }
    }
    function setMedia(i) {
      $$('.pd__main .m', wrap).forEach(function (m) { m.classList.toggle('is-on', m.getAttribute('data-i') === String(i)); });
      $$('.pd__thumbs button', wrap).forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-i') === String(i)); });
    }
    $$('.opt input', wrap).forEach(function (i) { i.addEventListener('change', update); });
    $$('.pd__thumbs button', wrap).forEach(function (b) { b.addEventListener('click', function () { setMedia(b.getAttribute('data-i')); }); });
    $$('[data-q]', wrap).forEach(function (b) {
      b.addEventListener('click', function () {
        var n = parseInt(qtyEl.value, 10) || 1;
        n = clamp(n + parseInt(b.getAttribute('data-q'), 10), 1, 99);
        qtyEl.value = n; var s = $('.qty span', wrap); if (s) s.textContent = n;
      });
    });
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!idInput || !idInput.value || (btn && btn.disabled)) return;
      var info = { title: wrap.getAttribute('data-title'), price: (selected() || {}).price || 0, url: W.location.pathname, imageHtml: ($('.pd__main .m.is-on', wrap) || {}).innerHTML || '' };
      var qty = parseInt(qtyEl && qtyEl.value, 10) || 1;
      if (btn) { btn.disabled = true; btn.textContent = 'Adding'; }
      Cart.add(idInput.value, qty, info).then(function (c) { renderCart(c); openDr('cart'); update(); })
        .catch(function (err) { toast(err.message || 'Could not add'); update(); });
    });
    update();
  }

  /* ------------------------------------------------ newsletter (demo only) */
  function initNewsletter() {
    if (!T.demo) return;
    $$('.nl__form').forEach(function (f) {
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        var m = $('.nl__msg', f); if (m) m.textContent = 'Thanks! You are on the crew list.';
      });
    });
  }

  /* ------------------------------------------------ collection sort */
  function initSort() {
    $$('select[data-sort]').forEach(function (s) {
      s.addEventListener('change', function () {
        var u = new URL(W.location.href);
        u.searchParams.set('sort_by', s.value);
        u.searchParams.delete('page');
        W.location.href = u.toString();
      });
    });
  }

  /* ------------------------------------------------ footer scroll */
  function initFooter() {
    var ft = $('.ft');
    if (!ft || reduce) return;
    var tick = false;
    function upd() {
      tick = false;
      var r = ft.getBoundingClientRect();
      var p = clamp(1 - r.top / W.innerHeight, 0, 1.4);
      ft.style.setProperty('--fp', p.toFixed(3));
    }
    W.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(upd); } }, { passive: true });
    upd();
  }

  /* ------------------------------------------------ boot */
  function boot() {
    W.__alienBoot = true;
    root.classList.remove('no-js'); root.classList.add('js');
    initTransitions();
    initActions();
    initCatalog();
    initSlider();
    initProduct();
    initNewsletter();
    initSort();
    initHero();
    initFooter();
    initReveal();
    var hasCover = root.classList.contains('pxl-cover');
    var go = function () {
      if (hasCover && !reduce) { pixelFx('out'); setTimeout(startHero, 420); }
      else { root.classList.remove('pxl-cover'); startHero(); }
    };
    if (D.fonts && D.fonts.ready) { Promise.race([D.fonts.ready, new Promise(function (r) { setTimeout(r, 700); })]).then(go); }
    else go();
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', boot); else boot();
})();
